import React from "react";
import { Close } from "../../../assets/icons/Icons";

const CloseButton = ({ handleClick, className }: { handleClick: () => void; className?: string }) => {
  return (
    <button
      onClick={handleClick}
      className={className || "bg-closeBG p-1 rounded-full hover:bg-sbBorder focus:outline-none"}
      type="button"
    >
      <Close />
    </button>
  );
};

export default CloseButton;
